<template>
  <div id="codificator-builder-new-or-edit" class="wrapper-content w-100">
    <LmComponentLoading v-if="loading" fixed />
    <h1>Codificatorbuilder</h1>
    <LmForm ref="lmFormRef" >
      <portal-target name="destination-after-title" slim/>
      <LmCheckbox
        class="col-12 pl-0"
        v-model="formData.isChild"
        labelSingle="Es un codificator builder hijo"
      />
      <LmSuperPowerSelectV2
        v-if="visibilityDependOnIsChildCheckbox"
        v-model="formData.parentCodificatorBuilder"
        v-bind="superPowerSelectV2Props"
      />
      <LmTextInput
        class="col-12 px-0"
        :v="$v.formData.codificatorName"
        v-model="formData.codificatorName"
        label="Nombre del codificator builder"
        placeholder="Nombre"
      />
      <LmImportFromExcel
        class="col-12 px-0 mb-4"
        label="Importa codificadores desde un excel"
        placeholder="Carga tu archivo aqui..."
        pathForPostRequest="/codificator/"
        :availableFields="availableFieldsForExcelImport"
        :customParams="customParamsForExcelImport"
        v-if="editMode"
      />
    </LmForm>
    <LmUserPermissions
      className="col-6 px-0"
      :form="form"
    />
      <!-- FormBuilderUi -->
      <div id="lm-form-builder-ui" class="wrapper-content w-100 pl-0 mt-3">
      <h3>Propiedades personalizadas</h3>
      <div class="row position-relative">
        <div class="col-12 col-md-6">
          <LmForm ref="lmFormBuilderRef" id="form-builder-ui-form">
            <draggable
              class="col-12"
              v-model="form.formElements"
              @start="drag=true"
              @end="drag=false"
              >
              <div v-for="(formElement, index) in form.formElements" :key="formElement.id" class="mt-4 border border-primary">
                <header
                  class="d-flex justify-content-between align-items-center bg-primary text-white pr-3 pl-3"
                  :class="{'bg-info': !shouldCreatePortal(form.formElements[index].componentName)}">
                  <font-awesome-icon class="handle mr-4 bars" icon="bars" />
                  <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center">{{title(form.formElements[index])}}</h4>
                  <div v-if="shouldCreatePortal(form.formElements[index].componentName)" class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                  <div>
                    <font-awesome-icon v-b-toggle="`collapse-${index}`" class="ml-4 clickable" icon="chevron-down" />
                    <font-awesome-icon class="ml-4 clickable" icon="trash" @click="removeFormElement(index)" />
                  </div>
                </header>
                <b-collapse
                  accordion="my-accordion"
                  :id="`collapse-${index}`"
                  visible
                  class="p-4"
                  >
                  <LmSelect
                    :id="'select-elements-' + index"
                    v-model="form.formElements[index].componentName"
                    :options="generator.selectorElementTypeOptions"
                    label="Seleccione el tipo de elemento"
                    @input="selectorElementForm($event, index)"
                  />
                  <component
                    :is="whatComponentBuilderUse(form.formElements[index].componentName)"
                    :id="form.formElements[index].formObjectToSendToServerProperty || form.formElements[index].id"
                    :componentData="form.formElements[index]"
                    :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
                    :leftValueToCompareOptions="leftValueToCompareOptions(form.formElements[index])"
                    :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
                    :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
                    :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
                    :options="lmSuperPowerSelectV2BuilderUiOptions"
                    :isOnEditMode="isOnEditMode"
                    @input="inputHandler($event, index)"
                    @validations-changes="validationsChangesHandler"
                  />
                </b-collapse>
              </div>
            </draggable>
            <div class="col-12 pl-0">
              <LmButton
                id="add-field-button"
                class="mt-4"
                type="button"
                lmButtonRootWrapperClass="d-inline-block"
                lmButtonWrapperClass="col"
                @click.native="addFormElement(form.formElements.length)"
                value="Agregar un campo al formulario"
              />
            </div>
          </LmForm>
        </div>
      </div>
    </div>
    <!-- FormBuilderUi -->
    <div class="d-flex wrapper-content pl-0">
      <LmButton
        class="col-auto pl-0"
        v-bind="cancelButtonProps"
        id="cancelButton"
        @click.native="onCancel"
      />
      <LmButton
        :disabled="isDisabledByUserPrivileges()"
        class="col-auto"
        v-bind="saveButtonProps"
        id="saveButton"
        @click.native="onSubmit"
      />
      <LmButton
        v-if="editMode"
        class="col-auto"
        v-bind="deleteButtonProps"
        id="deleteButton"
        @click.native="onDelete"
      />
    </div>
    <p
      v-if="isDisabledByUserPrivileges()"
      class="font-italic text-danger"
    >
      Lo sentimos, no tiene permisos para guardar los cambios.
    </p>
  </div>
</template>

<script>
import {
  required
} from 'vuelidate/lib/validators'

import LmForm from '@/components/form/LmForm'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import LmImportFromExcel from '@/components/form/elements/LmImportFromExcel'
import draggable from 'vuedraggable'
import VueScrollTo from 'vue-scrollto'

import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmRepeatFieldsBuilderUi from '@/components/lmFormBuilderUi/LmRepeatFieldsBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import LmUploadFilesBuilderUi from '@/components/lmFormBuilderUi/LmUploadFilesBuilderUi'
import LmUserPermissions from '@/components/lmFormBuilderUi/LmUserPermissionsUi'

import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'

import { checkUserPermissions } from '@/helpers/userPermissions'

export default {
  components: {
    LmForm,
    LmSuperPowerSelectV2,
    LmTextInput,
    LmCheckbox,
    LmButton,
    LmSelect,
    LmImportFromExcel,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    draggable,
    LmCommentBuilderUi,
    LmRepeatFieldsBuilderUi,
    LmCheckboxBuilderUi,
    LmUploadFilesBuilderUi,
    LmUserPermissions
  },
  mixins: [lmToasts, lmFormBuilderUi],
  data () {
    return {
      formData: {
        codificatorName: '',
        isChild: false,
        parentCodificatorBuilder: {
          id: '',
          name: ''
        }
      },
      form: {
        validations: {},
        formElements: [],
        allowAccess: [],
        allowCreate: [],
        allowUpdate: []
      },
      initialForm: {},
      saveButtonProps: {
        isVisible: true,
        type: 'button',
        value: 'Guardar',
        buttonClass: 'btn-primary'
      },
      cancelButtonProps: {
        isVisible: true,
        type: 'cancel',
        value: 'Cancelar',
        buttonClass: 'btn-secondary'
      },
      deleteButtonProps: {
        isVisible: true,
        type: 'button',
        value: 'Eliminar',
        buttonClass: 'btn-danger'
      },
      superPowerSelectV2Props: {
        isVisible: true,
        options: [],
        multiple: false,
        label: 'Codificator builder padre',
        urlPathFromGetOptions: '/codificatorbuilder/parents/all',
        disabled: false
      },
      visibilityDependOnIsChildCheckbox: false,
      loading: false,
      editMode: false,
      formPermissions: {
        allowAccess: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_ALLOW_PERMISSIONS.split(',') || [],
        allowCreate: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_CREATE_PERMISSIONS.split(',') || [],
        allowUpdate: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_UPDATE_PERMISSIONS.split(',') || []
      },
      userPrivileges: {}
    }
  },
  validations: {
    formData: {
      codificatorName: {
        required
      }
    }
  },
  computed: {
    customParamsForExcelImport () {
      const params = []
      params.push({
        property: 'codificatorBuilderId',
        value: this.$route.params.id
      })
      if (this.formData.isChild) {
        params.push({
          property: 'parentCodificatorBuilder',
          value: this.formData.parentCodificatorBuilder
        })
      }
      return params
    },
    availableFieldsForExcelImport () {
      const obj = this.form.formElements.map(el => el.formObjectToSendToServerProperty)
      obj.push('name')
      return obj
    }
  },
  methods: {
    updateForm (formDataFromLmFormBuilder) {
      for (const key in formDataFromLmFormBuilder) {
        this.formData[key] = formDataFromLmFormBuilder[key]
      }
    },
    async onSubmit () {
      const codificatorbuilderData = {
        ...this.formData,
        formBuilderCustomFields: [...this.form.formElements],
        customFieldsValidations: this.form.validations,
        formbuilderPermissions: {
          allowAccess: this.form.allowAccess,
          allowCreate: this.form.allowCreate,
          allowUpdate: this.form.allowUpdate
        }
      }
      if (this.editMode) {
        codificatorbuilderData.editMode = true
      }
      await this.validationForm(this.$v, false)
      try {
        this.loading = true
        if (this.editMode) {
          const r = await commonsApi.axiosPutWrapper(`/codificatorbuilder/${this.$route.params.id}`, codificatorbuilderData)
          this.lmToastSuccessMessage(`Se editó ${r?.data?.codificatorName || ' el codificador'} correctamente.`, 'Se guardó exitosamente')
        } else {
          const r = await commonsApi.axiosPostWrapper(`/codificatorbuilder/`, codificatorbuilderData)
          this.lmToastSuccessMessage(`Se creó ${r?.data?.codificatorName || ' el codificador'} correctamente.`, 'Se guardó exitosamente')
        }
        setTimeout(() => {
          this.loading = false
          this.$router.push(process.env.VUE_APP_CODIFICATOR_BUILDER_LISTBUILDER_PATH || '/listbuilder/view/60c0d82900088a3870b3f9de')
        }, 650)
      } catch (error) {
        this.loading = false
      }
    },
    async onDelete () {
      try {
        this.loading = true
        if (this.editMode) {
          await commonsApi.axiosPutWrapper(`/codificatorbuilder/delete/${this.$route.params.id}`)
          setTimeout(() => {
            this.$router.push(process.env.VUE_APP_CODIFICATOR_BUILDER_LISTBUILDER_PATH || '/listbuilder/view/60c0d82900088a3870b3f9de')
          }, 650)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    onCancel () {
      this.$router.push(process.env.VUE_APP_CODIFICATOR_BUILDER_LISTBUILDER_PATH || '/listbuilder/view/60c0d82900088a3870b3f9de')
    },
    leftValueToCompareOptions (formElementToExclude) {
      return {
        disabledOption: this.$t('Element'),
        content: this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).filter(e => e.id !== formElementToExclude.id).map(e => ({ value: e.formObjectToSendToServerProperty, text: e.componentProps.label }))
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    // async setForm () {
    //   if (this.isOnEditMode) {
    //     await this.$refs.lmFormRef.activeEditMode({
    //       path: 'formbuilder',
    //       id: this.$route.params.id,
    //       paramsMode: true
    //     })
    //   } else {
    //     this.form = JSON.parse(this.initialForm)
    //     this.$refs.lmFormRef.showLoading()
    //     setTimeout(() => {
    //       this.$v.$reset()
    //       this.$refs.lmFormRef.hideLoading()
    //     }, 350)
    //   }
    // },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    title (component) {
      const componentLabel = component?.componentProps?.label
      const componentValue = component?.componentProps?.value
      const componentText = component?.componentProps?.text
      const { text } = this.generator.selectorElementTypeOptions.content.find(e => e.value === component?.componentName)
      let moreInfo = ''
      if (componentLabel) {
        moreInfo += ' - ' + componentLabel
      } else if (componentValue) {
        moreInfo += ' - ' + componentValue
      } else if (componentText) {
        moreInfo += ' - ' + componentText
      }
      return text + moreInfo
    },
    addFormElement (elementIndex) {
      this.selectorElementForm('LmTextInput', elementIndex)
    },
    inputHandler (event, index) {
      this.form.formElements[index] = event
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    },
    showToastFormError (msg = this.$t('form_with_errors')) {
      this.$bvToast.toast(msg, {
        title: 'Error',
        toaster: 'b-toaster-bottom-center',
        variant: 'danger',
        solid: true
      })
    },
    errorScrollTo () {
      VueScrollTo.scrollTo(this.id, 1000, { offset: -60 })
    },
    validationForm (validation, mustShowToat = true) {
      validation.$touch()
      if (validation.$error) {
        if (mustShowToat) {
          this.showToastFormError()
        }
        this.errorScrollTo()
        return Promise.reject(new Error('validation error'))
      } else {
        if (!validation.$pending || !validation.$error) {
          return Promise.resolve(true)
        } else {
          Promise.reject(new Error('validation error'))
        }
      }
    },
    hideLoading () {
      this.loading = false
    },
    showLoading () {
      this.loading = true
    },
    async activeEditMode (getItemDetailObj, form = 'form') {
      try {
        this.isOnEditMode = true
        this.$emit('onEditMode', true)
        this.showLoading()
        const response = await commonsApi.getItemDetail({
          path: getItemDetailObj.path,
          id: getItemDetailObj.id,
          paramsMode: getItemDetailObj.paramsMode
        })
        this.$parent[form] = response
        this.hideLoading()
      } catch (error) {
        this.hideLoading()
        console.log('error: ', error)
        throw error
      }
    },
    isDisabledByUserPrivileges () {
      // Crear
      if (!this.userPrivileges.allowCreate && !this.editMode) {
        return true
      }
      // Actualizar
      if (!this.userPrivileges.allowUpdate && this.editMode) {
        return true
      }
      return false
    }
  },
  watch: {
    // isOnEditMode () {
    //   this.setForm()
    // },
    'formData.isChild' (newVal) {
      if (newVal) {
        this.visibilityDependOnIsChildCheckbox = true
      } else {
        this.formData.parentCodificatorBuilder.id = ''
        this.formData.parentCodificatorBuilder.name = ''
        this.visibilityDependOnIsChildCheckbox = false
      }
    }
  },
  async created () {
    // Set mode
    this.editMode = !!this.$route.params.id

    // Check user permissions
    this.userPrivileges = checkUserPermissions(this.formPermissions)
    if (!this.userPrivileges.allowAccess) {
      this.$router.push('/')
    }

    try {
      this.loading = true
      this.initialForm = JSON.stringify(this.form)

      if (this.editMode) {
        const { data } = await commonsApi.axiosGetWrapper(`codificatorbuilder/${this.$route.params.id}`)
        this.formData = {
          codificatorName: data.codificatorName,
          isChild: data.isChild,
          parentCodificatorBuilder: data.parentCodificatorBuilder
        }
        this.form.formElements = data?.formBuilderCustomFields || []
        this.form.validations = data?.customFieldsValidations || {}
        this.form.allowAccess = data?.formbuilderPermissions?.allowAccess || []
        this.form.allowCreate = data?.formbuilderPermissions?.allowCreate || []
        this.form.allowUpdate = data?.formbuilderPermissions?.allowUpdate || []

        if (!this.editMode) {
          this.showLoading()
          setTimeout(() => {
            this.$v.$reset()
            this.hideLoading()
          }, 350)
        }
        await this.$nextTick()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }
  },
  async mounted () {
    // this.setForm()
  },
  beforeDestroy () {
    this.$bvToast.hide('lm-toast-success-internal-link')
  }
}
</script>

<style lang="sass" scoped>
.circle
  background: white
  color: black
  border-radius: 50%
  width: 25px
  height: 25px
  text-align: center
</style>
